
'format es6';

import ns from 'ns';
import $ from 'jquery';
import Store from 'store';
import User from '../User';
import gsap from 'greensock';
import Promise from 'Promise';

import Api from '../Api';
import Collapser from '../Collapser';
import Snippet from '../Snippet';
import Scroll from '../Scroll';
import { factory as sectionFactory } from './Section';

require('../../views-compiled/family');

const EASING = gsap.Expo;
const TOTAL_FAMILY_NUMBER = 14;
const TIME_TO_FACEBOOK_POPUP = 15000;
const FAMILY_FAVORITES_KEY = 'user.family_favorites';
const FAMILY_FAVORITES_MARK_KEY = 'user.family_favorites_marks';

function Family() {
	this.templateName = 'family.htm';

	let nextFamilyCta;
	let familiesCta;
	let backToDomainsCta;
	let shareCta;
        let subMenu;
	let careersFam;
	let savedFavorites;
  let savedFavoritesMarks;

	this.setAnimation = (tl, rootNode, setInEndTime) => {
		tl.from(rootNode, 0.3, { opacity: 0, ease: EASING.easeIn });
		const animateInFinish = setInEndTime();
		tl.to(rootNode, 0.3, { opacity: 0, ease: EASING.easeOut }, animateInFinish);
		return tl;
	};

	let data;
	this.setData = (id, currentDomainName, prc) => {
		return Api.request(`family/${ns.lang}/${id}`).then((loadedData) => {
			// Filter and rearrange programs as to categorise them
			// by program category (name)
			const programsPerName = {};
			loadedData[0].programs.forEach(program => {
				if (programsPerName[`${program.regime_etudes}`]) {
					programsPerName[`${program.regime_etudes}`].push(program);
				} else {
					programsPerName[`${program.regime_etudes}`] = [program];
				}
			});

			const formattedData = {};
			Object.keys(programsPerName).forEach(programName => {
				formattedData[programName] = {
					name: String(programName),
					sstitres: {},
				};
			});

			// Filter and rearrange the programsPerName Object as to categorise
			// each program, inside it's category, per cycle
			Object.keys(programsPerName).forEach(programName => {
				const programs = programsPerName[programName];
				programs.forEach(program => {
					if (formattedData[programName][`sstitres`][`${program.objectifs}`]) {
						formattedData[programName][`sstitres`][`${program.objectifs}`].push(program);
					} else {
						formattedData[programName][`sstitres`][`${program.objectifs}`] = [program];
					}
				});
			});

			// Set the data to be what we originally loaded
			data = loadedData[0];

			// Transform the rearranged programs to an array and set it to the 
			// data.programs key.
			data.programs = Object.keys(formattedData).map(key => formattedData[key]);

			// Sort strings with accents
			function strSort(a, b) {
				return a.localeCompare(b);
			}

			// Sort the careers and program groups arrays
			data.careers.sort((a, b) => strSort(a.nom, b.nom));
//			data.programs.sort((a, b) => strSort(a.name, b.name));

			// Sort each program in a program group in their respective cycle
//			data.programs.forEach((program) => {
//				if (program.cycle_1) {
//					program.cycle_1.sort((a, b) => {
//						if (a.numero_ref < b.numero_ref) return -1;
//						if (a.numero_ref > b.numero_ref) return 1;
//						return 0;
//					});
//				}
//
//				if (program.cycle_2) {
//					program.cycle_2.sort((a, b) => {
//						if (a.numero_ref < b.numero_ref) return -1;
//						if (a.numero_ref > b.numero_ref) return 1;
//						return 0;
//					});
//				}
//			});

			// Add useful data
			data.currentDomainName = currentDomainName;
			data.prc = prc;

			// There are only a set number of images (the same number as the number of families),
			// but the way the database treats them is to have a UID for both the french and 
			// english version. Therefore when we get to a UID bigger than the number of families,
			// we substract the number of families to get the "real" UID.
			if (data.uid > TOTAL_FAMILY_NUMBER) {
				data.uid = data.uid - TOTAL_FAMILY_NUMBER;
			}
//console.log(data);
		}).catch((res) => {
			console.log(res);
		});
	};

	this.init = () => Promise.resolve(data);

	this.activate = () => {
		dataLayer.push({
			'event': 'customEvent',
			'eventCategory': 'Cursus',
			'eventAction': 'famille',
			'eventLabel': data.nom
		});

		Collapser.init();
		Snippet.init();

		familiesCta = $('[data-family-cta]');
		nextFamilyCta = $('[data-next-family]');
		backToDomainsCta = $('[data-back-domains-cta]');
		shareCta = $('[data-share-cta]');
		subMenu = $('[data-sub-menu]');

		// NO POPUP TO SHARE ON FB! // Set a timeout for the facebook share popup
		// NO POPUP TO SHARE ON FB! this.timeout = setTimeout(() => {
		// NO POPUP TO SHARE ON FB! 	$.magnificPopup.open({
		// NO POPUP TO SHARE ON FB! 		items: {
		// NO POPUP TO SHARE ON FB! 			src: '#share-popup',
		// NO POPUP TO SHARE ON FB! 		},
		// NO POPUP TO SHARE ON FB! 		type: 'inline',
		// NO POPUP TO SHARE ON FB! 	});
		// NO POPUP TO SHARE ON FB! }, TIME_TO_FACEBOOK_POPUP);

		$('#close-instructions').on('click.udem', () => {
			$.magnificPopup.close();
		});

		subMenu.on('click.cursus', (e) => {
			e.preventDefault();
			Scroll.moveToContent($(e.currentTarget).data('target'));
		});

		shareCta.on('click.cursus', (e) => {
			e.preventDefault();
			Scroll.moveToContent($(e.currentTarget).data('target'));
		});

		// Go back to the domains (showProfileResult)
		backToDomainsCta.off('click.cursus').on('click.cursus', (e) => {
			e.preventDefault();
			this.next && this.next();
		});

		nextFamilyCta.on('click.cursus', (e) => {
			e.preventDefault();

			let nextFamily = familiesCta.filter('.current-item').next('[data-family-cta]');
			nextFamily = nextFamily.length === 0 ? familiesCta.eq(0) : nextFamily;

			nextFamily.trigger('click');
		});

    careersFam = $('[data-careers-fam]').data('careers-fam');
	  savedFavorites = Store.get(FAMILY_FAVORITES_KEY);
	  savedFavoritesMarks = Store.get(FAMILY_FAVORITES_MARK_KEY);
    if (savedFavoritesMarks == undefined) {
		  savedFavoritesMarks = {};
      savedFavoritesMarks[careersFam] = {};
    } else {
      if (savedFavoritesMarks[careersFam] == undefined) {
        savedFavoritesMarks[careersFam] = {};
      }
    }
console.log(savedFavorites);
console.log(savedFavoritesMarks);
	  if (savedFavorites == undefined) {
		  savedFavorites = {};
      savedFavorites[careersFam] = {};
    } else {
      //console.log(savedFavorites);
		  if (savedFavorites[careersFam] == undefined) {
        savedFavorites[careersFam] = {};
        savedFavoritesMarks[careersFam] = {};
      } else {
        //console.log(savedFavorites[careersFam]);
		    for (var f in savedFavorites[careersFam]) {
          if (savedFavoritesMarks[careersFam][f] == undefined) {
            savedFavoritesMarks[careersFam][f] = 'bticn-heart-1';
			      Store.set(FAMILY_FAVORITES_MARK_KEY, savedFavoritesMarks);
			      User.set(FAMILY_FAVORITES_MARK_KEY, savedFavoritesMarks, true);
          }
		      $('#career-'+f).removeClass('icn-ajouter').addClass(savedFavoritesMarks[careersFam][f]);
        }
      }
    }
		$('[data-favorite-control]').on('click.cursus', (e) => {
      e.stopPropagation();
			const clicked = $(e.currentTarget);
			//console.log(careersFam.data('careers-fam')+' : '+clicked.data('favorite-control')+' = '+clicked.data('favorite-name'));
      if (savedFavorites[careersFam][clicked.data('favorite-control')] == undefined) {
			  savedFavorites[careersFam][clicked.data('favorite-control')] = clicked.data('favorite-name');
			  savedFavoritesMarks[careersFam][clicked.data('favorite-control')] = 'bticn-heart-2';
			  clicked.removeClass('icn-ajouter').addClass('bticn-heart-2');
      } else {
        if (savedFavoritesMarks[careersFam][clicked.data('favorite-control')] == 'bticn-heart-2') {
			    savedFavoritesMarks[careersFam][clicked.data('favorite-control')] = 'bticn-heart-1';
			    clicked.removeClass('bticn-heart-2').addClass('bticn-heart-1');
        } else {
			    delete savedFavorites[careersFam][clicked.data('favorite-control')];
			    delete savedFavoritesMarks[careersFam][clicked.data('favorite-control')];
			    clicked.removeClass('bticn-heart-1').addClass('icn-ajouter');
        }
      }
			console.log(savedFavorites);
			console.log(savedFavoritesMarks);
			Store.set(FAMILY_FAVORITES_KEY, savedFavorites);
			Store.set(FAMILY_FAVORITES_MARK_KEY, savedFavoritesMarks);
			User.set(FAMILY_FAVORITES_KEY, savedFavorites, true);
			User.set(FAMILY_FAVORITES_MARK_KEY, savedFavoritesMarks, true);
		});

		// Google tag manager events 
		$('[data-career-control]').on('click.cursus_events', (e) => {
			const clicked = $(e.currentTarget);
			dataLayer.push({
				'event': 'customEvent',
				'eventCategory': 'Cursus',
				'eventAction': 'click profession',
				'eventLabel': clicked.data('career-control'),
			});
		});

		$('[data-cycle-control]').on('click.cursus_events', (e) => {
			const clicked = $(e.currentTarget);
			dataLayer.push({
				'event': 'customEvent',
				'eventCategory': 'Cursus',
				'eventAction': 'click cycle',
				'eventLabel': clicked.data('cycle-control'),
			});
		});

		$('[data-program-control]').on('click.cursus_events', (e) => {
			const clicked = $(e.currentTarget);
			dataLayer.push({
				'event': 'customEvent',
				'eventCategory': 'Cursus',
				'eventAction': 'click programme',
				'eventLabel': clicked.data('program-control'),
			});
		});
		$('[data-program-link]').on('click.cursus_events', (e) => {
			const clicked = $(e.currentTarget);
			dataLayer.push({
				'event': 'customEvent',
				'eventCategory': 'Cursus',
				'eventAction': 'click programme link',
				'eventLabel': clicked.data('program-link'),
			});
		});
	};

	this.deactivate = () => {
		// Clear the timeout for the share popup
		this.timeout && clearTimeout(this.timeout);
	};

	return this;
}


export function factory(instance) {
	return Family.call(sectionFactory(instance || {}));
}
